import '../BurkiSchererAG/framework/css/fonts.css';
import '../BurkiSchererAG/framework/css/normalized.css';
import '../BurkiSchererAG/framework/css/framework.css';
import '../BurkiSchererAG/framework/css/style.css';
import '../BurkiSchererAG/framework/css/grid.css';
import '../BurkiSchererAG/framework/css/flex-box.css';
import '../BurkiSchererAG/framework/css/layout.css';
import '../BurkiSchererAG/framework/css/spotlight.css';
import '../BurkiSchererAG/framework/css/navigation.css';
import '../BurkiSchererAG/framework/css/header.css';
import '../BurkiSchererAG/framework/css/headerTop.css';
import '../BurkiSchererAG/framework/css/changelanguage.css';
import '../BurkiSchererAG/framework/css/tinymce.css';
import '../BurkiSchererAG/framework/css/BSmmenu.css';
import '../BurkiSchererAG/framework/css/keyframe.css';
import '../BurkiSchererAG/framework/css/skin-blue.css';
import '../BurkiSchererAG/framework/css/skin-red.css';
import '../BurkiSchererAG/framework/css/accordion.css';
import '../BurkiSchererAG/framework/css/footer.css';
import '../BurkiSchererAG/framework/css/search.css';
import '../BurkiSchererAG/framework/css/social-links.css';
import '../BurkiSchererAG/framework/css/caymland.css';
import '../BurkiSchererAG/framework/css/dragdrop.css';
import '../BurkiSchererAG/framework/css/duktus-keula.css';

import $ from 'jquery';
global.$ = global.jQuery = $;

import '../BurkiSchererAG/framework/js/project_hydro';
import '../BurkiSchererAG/framework/js/jquery.ui.min';
import '../BurkiSchererAG/framework/js/jquery.ui.touch-punch';
import '../BurkiSchererAG/framework/js/dragdrop';

import './styles/app.scss';

import { Application } from "@hotwired/stimulus"
import { definitionsFromContext } from "@hotwired/stimulus-webpack-helpers"

window.Stimulus = Application.start()
window.Stimulus.debug = process.env.NODE_ENV === 'development'

const context = require.context("./controllers", true, /\.js$/)
window.Stimulus.load(definitionsFromContext(context))
